import moment from 'moment';
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import utils from './utils.js';
import Heading from '@/components/pageheader_component.vue';
import Popover from '@/components/popover_component.vue';
import axios from 'axios';
import LoaderPopover from '@/components/loaderpopover_component.vue';
//import { Validator } from 'simple-vue-validator';
export default {
    name: 'Editbooking',
    components: {
        DatePicker,
        Heading,
        LoaderPopover,
        Popover
    },
    data() {
        return{
            is_submitting:false, // JOYWEB-2801: in-flight guard to prevent duplicate reschedule/edit submits
            url:'https://'+window.location.hostname+'/index.php/',
            cards:[],
            edit_customer_notes : false,
            cust_details:'',
            customer_bookings_details:'',
            services_list:[],
            booking_date:new Date(),
            multibooking:[],
            staff:[],
            booking_staff_notes:'',
            booked_services:[],
            booking_total:0,
            remove_popup : false,
            store_id:'',
            remove_type:'',
            remove_service_index:0,
            onload:true,
            send_mail:false,
            send_text:false,
            button1:'',
            button2:'',
            full_amount:0,
            deposite_amount:0,
            payed_deposite:0,
            payed_full_amount:0,
            previous_booking_details:[],
            changes_happened:false,
            page_title:'Edit Booking',
            previous_booking_date : '',
        }
    },
    filters: {
        human_date_format: function (date) {
          return moment(date).format('DD MMM YYYY, hh:mm A');
        },
    },
    created(){
        this.$store.state.loader_popup = true
        this.store_id=this.$session.get('store_id');
        this.get_staff();
       
    },
    computed:{
        get_current_date(){
            this.update_button_text();
            return moment(this.booking_date).format('ddd, MMM D, YYYY');
        },
    },
    mounted(){
        this.get_payment_details();
        if(this.$session.get('booking_type') == this.Constants.BOOKING_TYPE_RESCHEDULE_BOOKING)this.page_title = 'Booking Reschedule'
    },
    methods:{

        get_payment_details(){
            axios.post(this.$store.state.api +'transactions/get_bookings_payment_amount',{ 
                "book_id": this.$session.get('book_id'),
                "multi_book_id":this.$session.get('multi_book_id')
            }).then(response => {
                this.full_amount = response.data.result.pay_fullamount;
                this.deposite_amount = response.data.result.pay_deposit;
                if(this.deposite_amount == 0 && this.full_amount != 0){
                    this.button1 = 'Close';
                    this.button2 = 'Pay balance'
                }
                else if(this.deposite_amount != 0){
                    this.button1 = 'Close';
                    this.button2 = 'Pay now'
                }
                var bookings = response.data.result.bookings;
                for(var index = 0; index < bookings.length; index++){
                    if(bookings[index].due_book_deposit == 0) this.payed_deposite += bookings[index].book_deposit;
                    if(bookings[index].due_book_fullamount == 0) this.payed_full_amount += bookings[index].book_fullamount;
                }  
            })
        },
        get_services(){
            this.cards=[];
            axios.post(this.$store.state.api+`get_booking_details`,{
                "services": {"book_id":this.$session.get('book_id'),"multi_service_book_id":this.$session.get('multi_book_id')},
                "edit_flag":1
            }).then(async response => {
                
                this.onload=false
                this.booked_services = response.data.result.services;
                if(this.booked_services.length < 1) {
                    alert("No Services Found....!")
                    this.$router.push('/calendar');
                }
                else{
                    this.get_customer_details(this.booked_services[0].cust_id);
                    var index=0;
                    this.booking_total = 0;
                    this.booked_services.forEach(booking => {
                        // Keep a saved zero distinct from an absent value. The service lookup below
                        // only supplies defaults for absent buffers.
                        var saved_pre_buffer = (typeof booking.book_prebuffertime != 'undefined' && booking.book_prebuffertime !== null) ? booking.book_prebuffertime : '';
                        var saved_post_buffer = (typeof booking.book_postbuffertime != 'undefined' && booking.book_postbuffertime !== null) ? booking.book_postbuffertime : '';
                        this.multibooking.push({book_id:booking.book_id,multi_service_book_id:booking.multi_service_book_id,book_oldbookid:booking.book_oldbookid,services_list:[],serv_id:booking.serv_id,user_id:booking.user_id,book_fullamount:booking.book_fullamount,book_deposit:booking.book_deposit, serv_start_time:moment(booking.book_start_time,["HH:mm"]).format('HH:mm'),serv_end_time:moment(booking.book_end_time,["HH:mm"]).format('HH:mm'),serv_duration:booking.book_duration,pre_buffer:saved_pre_buffer,post_buffer:saved_post_buffer,serv_cat_id:booking.serv_cat_id,error_message:'',unmapped_selected_error:false,endtime_mismatch:false})
                        this.booking_total += booking.book_fullamount;
                        this.cards.push({index:index,service_index:`S${index+1}`});
                        index++;
                    
                    });
                    // get_services_by_staff_id() uses a shared Vuex result. Hydrate sequentially before
                    // taking the baseline so service defaults are not mistaken for user edits.
                    for(var service_index = 0; service_index < this.booked_services.length; service_index++){
                        await this.get_services_by_staff_id(this.booked_services[service_index].user_id,service_index,false);
                    }
                    this.previous_booking_details = JSON.parse(JSON.stringify(this.multibooking));
                    this.booking_staff_notes=this.booked_services[0].book_staff_note;
                    if(this.$session.get('booking_type') == this.Constants.BOOKING_TYPE_RESCHEDULE_BOOKING){
                        var reschedule_data = this.$session.get('reschedule_data');
                        await this.get_services_by_staff_id(reschedule_data.selected_staff,0,false)
                        this.booking_date = reschedule_data.droped_date;
                        this.multibooking[0].user_id = reschedule_data.selected_staff;
                        this.multibooking[0].serv_start_time = reschedule_data.start_time;
                        this.multibooking[0].serv_end_time = reschedule_data.end_time;
                    }
                    else{
                        this.booking_date = this.booked_services[0].book_start_date;
                        this.previous_booking_date = this.booking_date;
                    } 
                    this.$store.state.loader_popup = false;
                }
            })
        },

        update_total_value(){
            this.booking_total = 0;
            this.multibooking.forEach(booking => {
                this.booking_total += parseInt(booking.book_fullamount)
            });
        },

        change_date(){
            document.getElementById('select_date').click();
        },

        async add_service_card (add_card){
            var count=this.cards.length;
            if(count > 0){
                if(this.multibooking[count-1].serv_id == ''){
                    this.multibooking[count-1].error_message = 'Fill the Booking details completly to add new service';
                }
                else if (this.multibooking[count-1].serv_start_time == 'Start Time') {
                    this.multibooking[count-1].error_message = 'Fill the Booking details completly to add new service';
                }
                else this.multibooking[count-1].error_message=''
                await this.check_slot_availability(count-1)
                var serv_start_time = moment(this.multibooking[count-1].serv_end_time, "HH:mm").add(this.multibooking[count-1].post_buffer, "minutes").format('HH:mm');
                var split_time = serv_start_time.split(":");
                var start_time_minute = utils.round_to_near_5min(split_time[1]);
                if(parseInt(start_time_minute) < 10) serv_start_time = split_time[0]+":0"+utils.round_to_near_5min(split_time[1])
                else serv_start_time = split_time[0]+":"+utils.round_to_near_5min(split_time[1])
                if(this.multibooking[count-1].error_message.length == 0 && add_card == true){
                    this.cards.push({index:count,service_index:'S'+(count+1)});
                    this.multibooking.push({book_id:'',multi_service_book_id:'',services_list:[],serv_id:'',user_id:this.staff[0].user_id,book_fullamount:'',book_deposit:0,serv_start_time:serv_start_time,serv_end_time:'End Time',serv_duration:'',pre_buffer:'',post_buffer:'',serv_cat_id:'',error_message:'',unmapped_selected_error:false,endtime_mismatch:false});
                    this.get_services_by_staff_id(this.staff[0].user_id,count,true);
                }
            }
            else{
                this.cards.push({index:count,service_index:'S'+(count+1)});
                this.multibooking.push({book_id:'',multi_service_book_id:'',services_list:[],serv_id:'',user_id:this.staff[0].user_id,book_fullamount:'',book_deposit:0,serv_start_time:'Start Time',serv_end_time:'End Time',serv_duration:'',pre_buffer:'',post_buffer:'',serv_cat_id:'',error_message:'',unmapped_selected_error:false,endtime_mismatch:false});
                this.get_services_by_staff_id(this.staff[0].user_id,count,true);
            }
            
        },



        check_slot_availability(booking_index){
            var staff_id = this.multibooking[booking_index].user_id;
            var start_time = moment(this.multibooking[booking_index].serv_start_time,'hh:mm')
            var end_time = moment(this.multibooking[booking_index].serv_end_time,'hh:mm');
            var beforeTime = '';
            var afterTime = '';
            var slot_alredy_exist = false;
            if(this.multibooking.length >1){
                if(this.multibooking[booking_index].error_message == '' && this.multibooking[booking_index].serv_id != ''){
                    this.re_check_slot_availability(booking_index);
                }
                if(this.multibooking[booking_index].serv_id != ''){
                    for(var index = 0 ; index < this.multibooking.length ; index++){
                        if(booking_index != index && this.multibooking[index].user_id == staff_id){
                            beforeTime = moment(this.multibooking[index].serv_start_time,'hh:mm');
                            afterTime = moment(this.multibooking[index].serv_end_time,'hh:mm');
                            if (start_time.isBetween(beforeTime, afterTime) || end_time.isBetween(beforeTime, afterTime) || start_time.isSame(beforeTime) || end_time.isSame(afterTime) || beforeTime.isBetween(start_time,end_time) || afterTime.isBetween(start_time,end_time)) {

                                this.multibooking[booking_index].error_message = 'Time slot is overlapping with other bookings please change accordingly';
                                slot_alredy_exist = true;
                            }
                         }
                    }
                    if(!slot_alredy_exist){
                        this.multibooking[booking_index].error_message = '';
                    }
                }
                else{
                    this.multibooking[booking_index].error_message = 'Select the service before you choose the next step';
                    if(booking_index != 0){
                        this.multibooking[booking_index].serv_start_time = this.multibooking[booking_index-1].serv_end_time;
                        this.multibooking[booking_index].serv_end_time = '';
                    }
                }
            }
            if(moment(this.multibooking[booking_index].serv_end_time,["HH:mm"]) < moment(this.multibooking[booking_index].serv_start_time,["HH:mm"]))
                {
                    this.multibooking[booking_index].error_message = "End Time was exceeding selected date Please select other slot"
                }
        },

        re_check_slot_availability(selected_index){
            for(var booking_index = 0;booking_index < this.multibooking.length;booking_index++){
                if(this.multibooking[booking_index].user_id == this.multibooking[selected_index].user_id){
                    var staff_id = this.multibooking[booking_index].user_id;
                    var start_time = moment(this.multibooking[booking_index].serv_start_time,'hh:mm')
                    var end_time = moment(this.multibooking[booking_index].serv_end_time,'hh:mm');
                    var beforeTime = '';
                    var afterTime = '';
                    var slot_alredy_exist = false;
                    
                    for(var index = 0 ; index < this.multibooking.length ; index++){
                        if(booking_index != index && this.multibooking[index].user_id == staff_id){
                            beforeTime = moment(this.multibooking[index].serv_start_time,'hh:mm');
                            afterTime = moment(this.multibooking[index].serv_end_time,'hh:mm');
                                if (start_time.isBetween(beforeTime, afterTime) || end_time.isBetween(beforeTime, afterTime) || start_time.isSame(beforeTime) || end_time.isSame(afterTime) || beforeTime.isBetween(start_time,end_time) || afterTime.isBetween(start_time,end_time)) {
                                slot_alredy_exist = true;
                            }
                        }
                    }
                    if(!slot_alredy_exist){
                        this.multibooking[booking_index].error_message = '';
                    }
                }
            }

        },

        get_customer_details(id){
            axios.post(this.$store.state.api + `get_customer_details`, {
                "owner_id":this.$store.state.user_id,
                "cust_id":id
            }).then(response => {
                this.cust_details = response.data.result.customer.customer_details[0];
                if(!this.cust_details.cust_picture || (this.cust_details.cust_picture == 'null')) this.cust_details.cust_picture = '';
                this.customer_bookings_details = response.data.result; 
                if(this.cust_details.send_email == 1) this.send_mail = true;
                if(this.cust_details.send_text == 1) this.send_text = true;   
            })
        },

        async get_services_by_staff_id(staff_id,index,change_end_time_slot){
            await this.$store.dispatch('getServicesByStaffID',[this.$store.state.api,this.store_id,staff_id]);
            this.multibooking[index].services_list = this.$store.state.services_by_staff;
            this.update_service_card_details(index,change_end_time_slot);
            
        },

        async get_staff(){
            await this.$store.dispatch('getStaffByStoreId',[this.$store.state.api,this.store_id]);
            this.staff=this.$store.state.store_staff_ids;
            if(this.onload == true){
                this.get_services();
            }
        },

        update_service_card_details(index,change_end_time_slot){
            if(this.multibooking[index].serv_id != ''){
                var service_id = this.multibooking[index].serv_id;
                this.multibooking[index].services_list.mapped_services.forEach(services => {
                    services.services.forEach(service=>{
                        if(service.serv_id == service_id){
                            this.multibooking[index].book_fullamount=service.serv_saleprice;
                            this.multibooking[index].book_deposit=service.serv_deposit;
                            this.multibooking[index].serv_duration=service.serv_defdur;
                            if(this.multibooking[index].pre_buffer === '' || this.multibooking[index].pre_buffer === null || typeof this.multibooking[index].pre_buffer === 'undefined') this.multibooking[index].pre_buffer = service.serv_prebuffertime;
                            if(this.multibooking[index].post_buffer === '' || this.multibooking[index].post_buffer === null || typeof this.multibooking[index].post_buffer === 'undefined') this.multibooking[index].post_buffer = service.serv_postbuffertime;
                            this.multibooking[index].serv_cat_id = service.serv_cat_id;
                            this.multibooking[index].unmapped_selected_error = false;
                        }
                    })
                    
                });
                this.multibooking[index].services_list.unmapped_services.forEach(services => {
                    services.services.forEach(service=>{
                        if(service.serv_id == service_id){
                            this.multibooking[index].book_fullamount=service.serv_saleprice;
                            this.multibooking[index].book_deposit=service.serv_deposit;
                            this.multibooking[index].serv_duration=service.serv_defdur;
                            if(this.multibooking[index].pre_buffer === '' || this.multibooking[index].pre_buffer === null || typeof this.multibooking[index].pre_buffer === 'undefined') this.multibooking[index].pre_buffer = service.serv_prebuffertime;
                            if(this.multibooking[index].post_buffer === '' || this.multibooking[index].post_buffer === null || typeof this.multibooking[index].post_buffer === 'undefined') this.multibooking[index].post_buffer = service.serv_postbuffertime;
                            this.multibooking[index].serv_cat_id = service.serv_cat_id;
                            this.multibooking[index].unmapped_selected_error = true;
                        }
                    })
                });
                if(change_end_time_slot == true)this.update_End_time(index, this.multibooking[index].serv_duration);
                this.update_total_value();
                if(this.multibooking[index].error_message != ""){
                this.add_service_card(false);
                }
            }
            this.update_button_text();
        },
        service_updated(index){
            // A newly selected service should receive that service's defaults. Existing saved/manual
            // values remain intact during initial load and staff changes.
            this.multibooking[index].pre_buffer = '';
            this.multibooking[index].post_buffer = '';
            this.update_service_card_details(index,true);
        },
        update_End_time(index,serv_duration){
            if(this.multibooking[index].serv_id != '') this.multibooking[index].serv_end_time = moment(this.multibooking[index].serv_start_time,["HH:mm"]).add(serv_duration, 'minutes').format('HH:mm');
            if(this.multibooking[index].error_message != ""){
                this.add_service_card(false);
            }
            this.check_slot_availability(index);
            this.update_button_text();
        },

        remove_card(index,type){  
           this.remove_type = type;
            this.remove_service_index = index;
            this.remove_popup = true;
              
        },

        remove_service_card(){
           if(this.multibooking[this.remove_service_index].book_id != ''){
            this.$store.commit('service_status_update',[this.multibooking[this.remove_service_index].book_id,0,this.Constants.STATUS_EARLY_CANCELLED,this.$store.state.user_id,this.Constants.BOOKED_THROUGH_ADMIN,this.Constants.EDIT_FLAG]);
           }
           if(this.multibooking.length == this.previous_booking_details.length)this.previous_booking_details.splice(this.remove_service_index,1);
            this.cards.splice(this.cards.length-1,1);
            this.multibooking.splice(this.remove_service_index,1);
            this.update_total_value(); 
            this.remove_popup = false;
            this.update_button_text();
        },

        remove_popup_card(){
            this.remove_popup = false;
        },

        end_time_validation(index){
            var start_time = this.multibooking[index].serv_start_time;
            var duration = this.multibooking[index].serv_duration;
            var end_time = this.multibooking[index].serv_end_time;
            var difference = ((moment(end_time,["HH:mm"]) - moment(start_time,["HH:mm"]))/60)/1000
            if(difference <= 0){
                this.multibooking[index].serv_end_time = moment(this.multibooking[index].serv_start_time,["HH:mm"]).add(duration, 'minutes').format('HH:mm');
                this.multibooking[index].endtime_mismatch = false;
            }
            else if(duration > difference){
                this.multibooking[index].endtime_mismatch = true;
            }
            else this.multibooking[index].endtime_mismatch = false;
            this.check_slot_availability(index);
            this.update_button_text();

        },

        buffer_updated(index){
            // Normalise Set up / Clean up to a non-negative whole number of minutes rounded to 5.
            var normalise_buffer = function(value){
                value = parseInt(value);
                if(isNaN(value) || value < 0) return 0;
                return utils.round_to_near_5min(value);
            };
            this.multibooking[index].pre_buffer = normalise_buffer(this.multibooking[index].pre_buffer);
            this.multibooking[index].post_buffer = normalise_buffer(this.multibooking[index].post_buffer);
            this.update_button_text();
        },

        // JOYWEB-2621: +/- stepper for the Set up / Clean up controls. field is 'pre_buffer'
        // or 'post_buffer'; delta is +/-5 min. Clamps at 0 and re-runs buffer_updated so the
        // value is normalised the same way as a direct edit.
        step_buffer(index, field, delta){
            var current = parseInt(this.multibooking[index][field]);
            if(isNaN(current)) current = 0;
            var next = current + delta;
            if(next < 0) next = 0;
            this.multibooking[index][field] = next;
            this.buffer_updated(index);
        },

        update_booking_notes(){
            if(this.multibooking.length){
                if(this.multibooking[0].book_id != '' && this.multibooking[0].book_id != undefined){
                    axios.post(this.$store.state.api +'booking/update_booking_notes',{
                    "book_id":this.multibooking[0].book_id,
                    "book_notes":this.booking_staff_notes,
                    "multi_service_book_id":this.multibooking[0].multi_service_book_id
                    })
                }  
            }
        },

        async update_customer_notes(){
            await this.$store.dispatch('update_customer_notes',[this.$store.state.api,this.cust_details.cust_id,this.$store.state.user_id,this.cust_details.cust_notes,this.$store.state.user_id])
            if(this.cust_details.cust_notes.length != 0){
                this.$refs.edit_cust_notes.innerHTML = 'Saved';
                this.$refs.edit_cust_notes.style.cssText="background: #10A377 !important";
            }
            this.save_cust_notes();  
        }, 

        edit_cust_notes(){
            this.edit_customer_notes = true;
            let _this = this;
            setTimeout(function(){
                _this.$refs.cust_notes.focus();
            },100);
        },

        save_cust_notes(){
            let _this = this;
            setTimeout(function(){
                        _this.edit_customer_notes = false; 
                    },700);

        },

        submit_booking(status){
            if(status == 'Close' || status == 'Cancel') this.$router.push('/calendar');
            else if(status == 'Pay Now') this.payment('pay');
            else this.payment('Unpay');
        },

        payment(status){
            if(this.is_submitting) return; // JOYWEB-2801: block duplicate submits (double-tap / slow network)
            var count=this.cards.length;
            if(count > 0){
                if(this.multibooking[count-1].serv_id == ''){
                    this.multibooking[count-1].error_message = 'Select the service before you choose the next step';
                }
                else if(this.multibooking[count-1].error_message != 'End Time was exceeding selected date Please select other slot'){
                    this.$store.state.loader_popup = true;
                    var booking_data= [];
                    for(var index=0;index < this.multibooking.length;index++){
                        booking_data.push({
                            "book_id":this.multibooking[index].book_id,
                            "multi_service_book_id":this.multibooking[index].multi_service_book_id,
                            "book_oldbookid":this.multibooking[index].book_oldbookid,
                            "serv_id" :this.multibooking[index].serv_id,
                            "serv_cat_id" :this.multibooking[index].serv_cat_id,
                            "user_id":this.multibooking[index].user_id,
                            "user_staff_type_id" :1,
                            "book_start_date":  moment(this.booking_date).format('yyyy-MM-DD'),
                            "book_end_date" :  moment(this.booking_date).format('yyyy-MM-DD'),
                            "book_start_time" : moment(this.multibooking[index].serv_start_time,["HH:mm"]).format('HH:mm:ss'),
                            "book_end_time" : moment(this.multibooking[index].serv_end_time,["HH:mm"]).format('HH:mm:ss'),
                            "book_duration" : this.multibooking[index].serv_duration,
                            "book_fullamount" :this.multibooking[index].book_fullamount,
                            "book_deposit": this.multibooking[index].book_deposit,
                            "book_staff_note" : this.booking_staff_notes,
                            "serv_prebuffertime": parseInt(this.multibooking[index].pre_buffer) || 0,
                            "serv_postbuffertime": parseInt(this.multibooking[index].post_buffer) || 0
                        });
                    }
                    this.is_submitting = true; // JOYWEB-2801: set right before the POST (synchronous up to here)
                    axios.post(this.$store.state.api +'booking/insert',{
                        "store_id" :this.store_id,
                        "cust_id" :this.cust_details.cust_id,
                        "book_first_name": this.cust_details.cust_first_name,
                        "book_last_name": this.cust_details.cust_last_name,
                        "book_email": this.cust_details.cust_email,
                        "book_country_isd_code" : this.cust_details.cust_country_isd_code,
                        "book_mobile" : this.cust_details.cust_mobile,
                        "book_updated_by":this.$session.get('owner_id'),
                        "updated_through": 1,
                        "book_created_by":this.$store.state.user_id,
                        "booked_through": 1,
                        "booking_type":this.$session.get('booking_type'),
                        "save_unpaid_status":1,
                        "service_details":booking_data,
                        "sms_send":this.send_text,
                        "email_send":this.send_mail

                    }).then(response=> {
                        this.is_submitting = false;
                        this.$store.state.selected_date = moment(this.booking_date).format('yyyy-MM-DD');

                        this.$session.set('book_id',response.data.result.bookings[0].book_id)
                        this.$session.set('multi_book_id',response.data.result.bookings[0].multi_book_id)
                        
                        if(this.$session.get('booking_type') == this.Constants.BOOKING_TYPE_EDIT_BOOKING){
                            this.$session.set('toast_title','Booking Updated');
                        }
                        else this.$session.set('toast_title','Reschedule Successful');
                        this.$session.set('toast_message','Appointment Details Updated');

                        if(status == 'pay'){
                            var payment_details = {
                                "cust_id":this.cust_details.cust_id,
                                "book_id":response.data.result.bookings[0].book_id,
                                "multi_book_id":response.data.result.bookings[0].multi_book_id
                            }
                            this.$session.set('payment_details',payment_details);
                            this.$router.push('/payment');
                        }
                        else{
                            this.$session.set('show_toast',true);
                            this.$router.push('/viewbooking');
                        }
                        this.$store.state.loader_popup = false;
                    }, () => {
                        // JOYWEB-2801: release the guard + loader on failure so the user can retry
                        this.is_submitting = false;
                        this.$store.state.loader_popup = false;
                    })
                }
            }
        },
        update_button_text(){
            this.changes_happened = false;
            if(this.multibooking.length != this.previous_booking_details.length){
                this.changes_happened = true
            }else{
                for(var booking_index = 0; booking_index < this.multibooking.length; booking_index++){
                    if(this.multibooking[booking_index].serv_id != this.previous_booking_details[booking_index].serv_id){
                        this.changes_happened = true;
                        break;
                    }
                    if(this.multibooking[booking_index].book_id != this.previous_booking_details[booking_index].book_id){
                        this.changes_happened = true;
                        break;
                    }
                    if(this.multibooking[booking_index].multi_service_book_id != this.previous_booking_details[booking_index].multi_service_book_id){
                        this.changes_happened = true;
                        break;
                    }
                    if(this.multibooking[booking_index].book_fullamount != this.previous_booking_details[booking_index].book_fullamount){
                        this.changes_happened = true;
                        break;
                    }
                    if(this.multibooking[booking_index].book_deposit != this.previous_booking_details[booking_index].book_deposit){
                        this.changes_happened = true;
                        break;
                    }
                    if(this.multibooking[booking_index].serv_start_time != this.previous_booking_details[booking_index].serv_start_time){
                        this.changes_happened = true;
                        break;
                    }
                    if(this.multibooking[booking_index].serv_end_time != this.previous_booking_details[booking_index].serv_end_time){
                        this.changes_happened = true;
                        break;
                    }
                    if(this.multibooking[booking_index].user_id != this.previous_booking_details[booking_index].user_id){
                        this.changes_happened = true;
                        break;
                    }
                    if(this.multibooking[booking_index].pre_buffer != this.previous_booking_details[booking_index].pre_buffer){
                        this.changes_happened = true;
                        break;
                    }
                    if(this.multibooking[booking_index].post_buffer != this.previous_booking_details[booking_index].post_buffer){
                        this.changes_happened = true;
                        break;
                    }
                }
            }
            if(moment(this.booking_date).format('dddd, MMM D YYYY') != moment(this.previous_booking_date).format('dddd, MMM D YYYY'))this.changes_happened = true;
            var book_deposite = 0;
            var book_full_amount = 0;
            this.button1 = '';
            this.button2 = '';
            for(var index = 0; index < this.multibooking.length; index++){
                book_deposite += this.multibooking[index].book_deposit;
                book_full_amount += this.multibooking[index].book_fullamount;
            }
            var pending_deposite = book_deposite - this.payed_deposite;
            var pending_full_amount = book_full_amount - this.payed_full_amount;
            if(pending_full_amount <= 0)
            {   
                this.button1 = 'Close';
                if(this.changes_happened)this.button2 = 'Save changes' 
            }
            if(pending_deposite > 0){
                this.button1 = 'Close';
                this.button2 = 'Pay Now';
                if(this.changes_happened)this.button1 = 'Save Booking'                 
            }else if(pending_full_amount > 0){
                this.button1 = 'Close';
                if(this.changes_happened)this.button1 = 'Save Booking' 
                this.button2 = 'Pay Now';
            }
            else this.button1 = 'Close'
            if(this.$session.get('booking_type') == this.Constants.BOOKING_TYPE_RESCHEDULE_BOOKING){if(this.button1 == 'Close'){this.button1 = 'Cancel'}}
        }

    }
}
